import { Route } from '@angular/router';

import { AppVariablesProviderComponent } from './app-variables-provider.component';
import { APP_VARIABLES_ROUTE_RESOLVER_KEY } from './app-variables.constants';
import { AppVariablesService } from './app-variables.service';

export const APP_VARIABLES_PROVIDER_MIDDLEWARE_ROUTE: Route = {
  path: '',
  component: AppVariablesProviderComponent,
  resolve: {
    [APP_VARIABLES_ROUTE_RESOLVER_KEY]: AppVariablesService,
  },
};
